import { FC } from 'react';
import { FlairProps } from './Flair.types';
import { Flex } from '@/_components/Flex/Flex';
import styles from './Flair.module.css';
import { getClasses } from '@/_utils/classnames';

export const Flair: FC<FlairProps> = ({ count, className }) => {
  if (count === 0) return null;

  const flairClasses: string = getClasses(className, styles.flair);

  return (
    <Flex isCentered={true} className={flairClasses}>
      {count}
    </Flex>
  );
};
